import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";

export default function Callback() {
  const { handleRedirectCallback } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    const process = async () => {
      try {
        await handleRedirectCallback();
        navigate("/");
      } catch (e) {
        console.error("Auth0 Redirect Error:", e);

        if (e.error === "access_denied") {
          navigate("/unauthorized", {
            state: { message: e.error_description },
          });
        } else {
          navigate("/error");
        }
      }
    };

    process();
  }, []);

  return <div>Loading...</div>;
}